import styled from '@emotion/styled';
import {
  Notification as NotificationUI,
  NotificationActive as NotificationActiveUI,
  Notif as NotifUI,
  Active as ActiveUI,
  Link as LinkUI,
  Button as ButtonUI,
} from 'ui';
import {colors, fonts} from 'ui/config';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  alignItems: 'center',
  width: '100%',
  maxWidth: 800,
  paddingLeft: 20,
  paddingRight: 20,
  backgroundColor: colors.greyLight,
  paddingBottom: 130,
});

export const Notification = styled(NotificationUI)({
  backgroundColor: colors.greyLight,
});

export const NotificationActive = styled(NotificationActiveUI)({
  backgroundColor: colors.greyLight,
});

export const Notif = styled(NotifUI)({
  backgroundColor: colors.greyLight,
});

export const Active = styled(ActiveUI)({
  backgroundColor: colors.greyLight,
});

const ButtonInner = styled(({size, color, ...p}) => <span {...p} />)(({color}) => ({
  fontFamily: fonts.title,
  fontWeight: 'bold',
  fontSize: 16,
  lineHeight: '19px',
  padding: '11px 0',
  textDecoration: 'none',
  border: `1px solid ${colors.white}`,
  color: color === 'white' ? colors.white : colors.caramel,
  backgroundColor: color === 'white' ? colors.caramel : colors.white,
  borderColor: color === 'white' ? colors.white : colors.caramel,
  width: 'inherit',
  maxWidth: 500,
  textAlign: 'center',
}));

export const ProfileLink = styled(({color, children, ...p}) => (
  <LinkUI {...p}>
    <ButtonInner color={color}>{children}</ButtonInner>
  </LinkUI>
))(({color}) => ({
  display: 'inline-flex',
  width: 217,
  padding: '2px 0',
  textAlign: 'center',
  backgroundColor: color === 'white' ? colors.caramel : colors.white,
  marginBottom: 16,
  textDecoration: 'none',
}));

export const ConditionsForm = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 13,
});

export const InfoRow = styled(({label, value, ...p}) => (
  <div {...p}>
    <span className="info-label">{label}</span>
    <span className="info-value">{value || '—'}</span>
  </div>
))({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '14px 0',
  '& .info-label': {
    fontSize: 14,
    color: colors.black,
  },
  '& .info-value': {
    fontSize: 14,
    color: colors.black,
    textAlign: 'right',
  },
});

export const OptionLabel = styled('label')({
  display: 'flex',
  alignItems: 'flex-start',
  color: colors.grey,
  fontSize: 14,
  lineHeight: '20px',
  cursor: 'pointer',
  gap: 10,
});

export const InputCheckbox = styled(({...p}) => <input type="checkbox" {...p} />)({
  position: 'absolute',
  appearance: 'none',
  border: 'none',
  cursor: 'pointer',
});

const CheckboxBox = styled('span')(({checked}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 20,
  minWidth: 20,
  height: 20,
  border: `1.5px solid ${checked ? colors.caramel : '#B0B0B0'}`,
  borderRadius: 4,
  backgroundColor: checked ? colors.caramel : 'transparent',
  color: colors.white,
  fontSize: 14,
  lineHeight: 1,
  marginTop: 1,
}));

export const Option = styled(({id, label, value, onChange, readOnly, ...p}) => (
  <div {...p}>
    <OptionLabel htmlFor={id} style={readOnly ? {opacity: 0.6, cursor: 'default'} : {}}>
      <InputCheckbox id={id} checked={!!value} onChange={onChange || (() => {})} readOnly={readOnly} />
      <CheckboxBox checked={!!value}>{value ? '\u2713' : ''}</CheckboxBox>
      {label}
    </OptionLabel>
  </div>
))({
  display: 'flex',
  flexDirection: 'column',
  marginTop: 0,
  cursor: 'pointer',
  paddingBottom: 4,
  marginBottom: 8,
});

export const Link = styled(LinkUI)({
  textAlign: 'left',
  width: '100%',
  textDecoration: 'underline',
  paddingBottom: 16,
  marginBottom: 17,
});

export const Button = styled(ButtonUI)({
  width: '100%',
  maxWidth: 500,
});

export const PushHelp = styled('p')({
  margin: '-4px 0 16px',
  fontSize: 13,
  lineHeight: '19px',
  color: colors.mauve,
});
